import { render, staticRenderFns } from "./AppAsideBar.vue?vue&type=template&id=ef07c25a&scoped=true"
import script from "./AppAsideBar.vue?vue&type=script&lang=js"
export * from "./AppAsideBar.vue?vue&type=script&lang=js"
import style0 from "./AppAsideBar.vue?vue&type=style&index=0&id=ef07c25a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef07c25a",
  null
  
)

export default component.exports